import { render } from "./manage_role.html?vue&type=template&id=47f1dc0c&external"
import script from "./manage_role.js?vue&type=script&lang=js&external"
export * from "./manage_role.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__